// Google Analytics 4 — Single Page Application tracker.
//
// We load gtag.js synchronously in index.html with ``send_page_view: false``
// so the library only initializes; no pageview is sent automatically. Each
// React Router transition then calls ``trackPageView`` below, giving us
// proper SPA analytics without double-counting the initial landing.
//
// Why not auto page_view? GA4 auto-tracking measures the FIRST URL only —
// every subsequent client-side route change goes uncounted. Disabling it
// and firing manually fixes the gap.

const GA_MEASUREMENT_ID = "G-KE6ESB5E13";

function getGtag() {
  if (typeof window === "undefined") return null;
  return typeof window.gtag === "function" ? window.gtag : null;
}

/**
 * Fire a GA4 page_view event for the current URL. Called once on mount
 * and once per route transition by ``GA4Tracker`` (mounted in App.js).
 *
 * ``page_path`` carries the SPA path (so /episodio/foo/bar shows up as
 * its own row in GA, not lumped under /); ``page_location`` carries the
 * full URL for cross-property attribution.
 */
export function trackPageView(pathname, search = "") {
  const gtag = getGtag();
  if (!gtag) return;
  const fullPath = `${pathname}${search || ""}`;
  // Tag para diferenciar tráfego PWA vs navegador. Útil no GA4
  // (segmentação por ``display_mode``: standalone vs browser) sem
  // fragmentar a propriedade — mesmo G-KE6ESB5E13.
  let displayMode = "browser";
  try {
    if (
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator.standalone === true
    ) {
      displayMode = "standalone";
    }
  } catch { /* noop */ }
  gtag("event", "page_view", {
    page_path: fullPath,
    page_location: window.location.href,
    page_title: document.title,
    display_mode: displayMode,
    send_to: GA_MEASUREMENT_ID,
  });
}

/**
 * Fire a custom GA4 event. Use for high-value interactions worth
 * tracking beyond raw pageviews — e.g. ``share_click``, ``add_to_collection``,
 * ``newsletter_subscribe``. Safe no-op when gtag hasn't loaded yet
 * (privacy plugins, network failures).
 */
export function trackEvent(name, params = {}) {
  const gtag = getGtag();
  if (!gtag) return;
  gtag("event", name, { ...params, send_to: GA_MEASUREMENT_ID });
}
